<template>
  <div class="tooltipCountry" style="border-radius: 100%;">
    <div style="vertical-align: top;display: inline-block; margin-top:-5px;">
      <country-flag :country="country" :size="size" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    meeting: Object,
    size: String
  },
  computed: {
    country() {
      return this.meeting?.track?.country || ''
    }
  },
  methods: {
    flagClass(country) {
      return `flag-${country}`
    },
    flagSmallClass(country) {
      return `flagSmall-${country}`
    }
  }
}
</script>

<style></style>
